import { CustomerService } from '../../_services/customer.service';
import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { DETAILSVIEWLABELS, SHAREDCONSTANTS } from '../../_constants/constants';
import { NotificationDialogComponent } from '../../notification/notification.dialog.component';

export interface CustomerUpdateModel {
    title: string;
    subValue: string;
    opcoValue: string;    
    customerService: CustomerService;
}

@Component({
    templateUrl: 'kyc.history.dialog.component.html'
})


export class KYCHistoryDialogComponent extends DialogComponent<CustomerUpdateModel, string> implements CustomerUpdateModel, OnInit {
    
    title: string;    
    subValue: string;
    opcoValue: string;
    kycHistoryData:any = [];
    customerService: CustomerService;
    kychistroylabels = DETAILSVIEWLABELS; 
    sharedlabels = SHAREDCONSTANTS;   
    isLoading:Boolean = false;
    
    offset:number = 0;
    page: number = 1;
    recordStart:number = 0;
    recordEnd:number;
    
    
    constructor(private ds: DialogService) {
        super(ds);
    }

    closePopup() {
        this.close();
    }

    ngOnInit(): void {

        this.kycHistoryData = this.customerService.getKycData().history;

        this.recordStart = (this.offset) + 1;
        this.recordEnd = parseInt(this.kycHistoryData.length) - (this.page * 10) < 0 ? (this.page * 10) + (parseInt(this.kycHistoryData.length) - (this.page * 10)) : this.page * 10;
    }

    getHistoryData(page){
        
        this.offset = (page - 1) * 10;
        this.page = page;        
        this.recordStart = (this.offset) + 1;
        this.recordEnd = parseInt(this.kycHistoryData.length) - (this.page * 10) < 0 ? (this.page * 10) + (parseInt(this.kycHistoryData.length) - (this.page * 10)) : this.page * 10;        
    }
}




// WEBPACK FOOTER //
// ./src/app/details/kyc/kyc.history.dialog.component.ts